export default {
  'menu.dashboard.workplace': 'Workplace (legacy)',
  'workplace.welcome': 'Welcome!',
  'workplace.balance': 'Balance (CNY)',
  'workplace.order.pending': 'Pending',
  'workplace.order.pendingRenewal': 'Renewal Order',
  'workplace.onlineContent': 'Online Content',
  'workplace.putIn': 'Put In',
  'workplace.newDay': 'Daily Additional Comments',
  'workplace.newFromYesterday': 'New From Yesterday',
  'workplace.stats.totalVisits': 'Total Visits',
  'workplace.stats.uniqueVisitors': 'Unique Visitors',
  'workplace.stats.pageViews': 'Page Views',
  'workplace.stats.avgDuration': 'Avg. Duration',
  'workplace.stats.ordersCount': 'Orders',
  'workplace.stats.ordersGmv': 'Order GMV',
  'workplace.stats.paidRevenue': 'Paid Revenue',
  'workplace.stats.newSubscriptions': 'New subscriptions',
  'workplace.stats.activeSubscriptions': 'Active subscriptions',
  'workplace.ordersTrend': 'Orders trend',
  'workplace.chart.ordersCount': 'Orders',
  'workplace.chart.ordersTrendHigh': 'High',
  'workplace.chart.ordersTrendLow': 'Low',
  'workplace.subscriptionsTrend': 'Subscriptions trend',
  'workplace.chart.subscriptionsNew': 'New subscriptions',
  'workplace.chart.subscriptionsCancelled': 'Cancelled subscriptions',
  'workplace.topShopsByGmv': 'Top shops by GMV',
  'workplace.topShopsByRevenue': 'Top shops by revenue',
  'workplace.topRegionsByOrders': 'Top regions by orders',
  'workplace.top.rank': 'No.',
  'workplace.top.shopId': 'Shop',
  'workplace.top.region': 'Region',
  'workplace.top.gmv': 'GMV',
  'workplace.top.revenue': 'Revenue',
  'workplace.top.orders': 'Orders',
  'workplace.subscriptionStatusPie': 'Subscription status',
  'workplace.subscriptionTotal': 'Subscriptions',
  'workplace.subscriptionCohort': 'Subscription cohort (by month)',
  'workplace.cohort.month': 'Cohort month',
  'workplace.cohort.new': 'New',
  'workplace.cohort.active': 'Active',
  'workplace.cohort.cancelled': 'Cancelled (as of end)',
  'workplace.cohort.activeRate': 'Active rate',
  'workplace.dashboardScopeHint':
    'No dashboard scope: sign in with a merchant-bound account, or set VITE_DASHBOARD_SHOP_IDS.',
  'workplace.minute': 'Min',
  'workplace.docs': 'Documents',
  'workplace.docs.productOverview': 'Product Overview',
  'workplace.docs.userGuide': 'User Guide',
  'workplace.docs.workflow': 'Workflow',
  'workplace.docs.interfaceDocs': 'Interface Docs',
  //
  'workplace.contentManagement': 'Content Management',
  'workplace.contentStatistical': 'Content Statistical',
  'workplace.advanced': 'Advanced',
  'workplace.onlinePromotion': 'Online Promotion',
  'workplace.contentPutIn': 'Put In',
  'workplace.announcement': 'Announcement',
  'workplace.recently.visited': 'Recently Visited',
  'workplace.record.nodata': 'No data',
  'workplace.quick.operation': 'Quick Operation',
  'workplace.quickOperation.setup': 'Setup',
  'workplace.allProject': 'All',
  'workplace.loadMore': 'More',
  'workplace.viewMore': 'More',
  'workplace.contentData': 'Content Data',
  'workplace.popularContent': 'Popular Content',
  'workplace.popularContent.text': 'text',
  'workplace.popularContent.image': 'image',
  'workplace.popularContent.video': 'video',
  'workplace.categoriesPercent': 'Categories Percent',
  'workplace.pecs': 'pecs',
  'workplace.realtimeVisitors': ' realtime visitors',

  // Orders dashboard / Subscriptions dashboard (new pages)
  'orders.stats.ordersCount': 'Orders',
  'orders.stats.gmv': 'GMV',
  'orders.stats.paidRevenue': 'Paid Revenue',
  'orders.stats.paidRevenueCnyWan': '≈ ¥{n}万 (CNY @ 6.8 per USD)',
  'orders.stats.paidRevenueCnyYi': '≈ ¥{n}亿 (CNY @ 6.8 per USD)',
  'orders.stats.paidRevenueCnyYuan': '≈ ¥{n} (CNY @ 6.8 per USD)',
  'orders.stats.paidOrdersCount': 'Paid orders',
  'orders.stats.paidRate': 'Conversion rate',
  'orders.realtime.newOrderTitle': 'New paid order',
  'orders.realtime.newOrderContent': 'Shop {shop} · {method} · ${amount}',
  'orders.paymentMethodSuccess': 'Payment channel mix & success rate',
  'orders.payment.method': 'Payment channel',
  'orders.payment.methodShare': 'Payment channel share',
  'orders.payment.orderShare': 'Share of payment attempts',
  'orders.payment.shareListEmpty': 'No payment channel data in this range',
  'orders.payment.orders': 'Payment attempts',
  'orders.payment.paid': 'Paid',
  'orders.payment.successRate': 'Success rate',
  'orders.payment.mode.real': 'Deduped',
  'orders.payment.mode.all': 'All',
  'orders.payment.successRateBlockSub': 'By payment attempts and success rate (payment flow)',
  'orders.payment.successDetailLine': '{attempts} attempts · {paid} succeeded',
  'orders.payment.successRateListEmpty': 'No success rate data in this range',
  'orders.payment.paidAmountByMethod': 'Paid amount by payment method',
  'orders.payment.paidAmountBlockSub': 'By paid amount (USD, same scope as the toggle above)',
  'orders.payment.paidAmountDetailLine': '{paid} paid · {share}% of total',
  'orders.payment.paidAmountListEmpty': 'No paid amount data in this range',
  'orders.payment.paidAmountTotal': 'Total',
  'orders.payment.paidRevenue': 'Paid Revenue',
  'orders.filters.title': 'Filters',
  'orders.filters.all': 'All',
  'orders.filters.merchant': 'Merchant',
  'orders.filters.shop': 'Shop',
  'orders.filters.range': 'Date range',
  'orders.filters.quickRange': 'Quick range',
  'orders.filters.timezone': 'Timezone',
  'orders.filters.timezoneLocal': 'Local timezone',
  'orders.filters.reset': 'Reset',
  'orders.filters.mobileHint': 'Tap to open filters',
  'orders.filters.today': 'Today',
  'orders.filters.yesterday': 'Yesterday',
  'orders.filters.thisWeek': 'This week',
  'orders.filters.last7d': 'Last 7 days',
  'orders.filters.last14d': 'Last 14 days',
  'orders.filters.last30d': 'Last 30 days',
  'orders.filters.thisMonth': 'This month',
  'orders.filters.thisQuarter': 'This quarter',
  'orders.filters.thisYear': 'This year',
  'orders.hourly.title': 'Orders by hour (24h)',
  'orders.hourly.ordersCount': 'Orders',
  'orders.ratio.title': 'Subscriptions share of paid orders',
  'orders.ratio.newSubscriptions': 'New subscriptions',
  'orders.ratio.deals': 'Paid orders',
  'orders.ratio.otherDeals': 'Non-subscription paid orders',
  'orders.ratio.subscriptionsRate': 'Subscriptions share',
  'subscriptions.stats.newSubscriptions': 'New subscriptions',
  'subscriptions.stats.activeSubscriptions': 'Active subscriptions',
  'subscriptions.stats.cancelledSubscriptions': 'Cancelled subscriptions',
  'subscriptions.upcomingRenewals.title': 'Upcoming renewals',
  'subscriptions.upcomingRenewals.hint': 'Starting today (not affected by date range)',
  'subscriptions.upcomingRenewals.count': '{n} records',
  'subscriptions.upcomingRenewals.maxHint': 'Up to {n} records',
  'subscriptions.renewalStats.title': 'Renewal stats',
  'subscriptions.renewalStats.hint': 'Date range',
  'subscriptions.renewalStats.txnSection': 'Renewal charges',
  'subscriptions.renewalStats.txnSectionDesc':
    'By renewal order time (real charge; paid = success)',
  'subscriptions.renewalStats.txnOrders': 'Renewal orders',
  'subscriptions.renewalStats.txnPaid': 'Success (paid)',
  'subscriptions.renewalStats.txnUnpaid': 'Failed (unpaid)',
  'subscriptions.renewalStats.txnPaidAmount': 'Paid amount',
  'subscriptions.renewalStats.txnSuccessCountSub': '{n} paid / renewal orders',
  'subscriptions.renewalStats.lifecycleSection': 'Due-subscription status',
  'subscriptions.renewalStats.lifecycleSectionDesc':
    'Current subscription status by next billing date in range',
  'subscriptions.renewalStats.subscriptionCount': 'Subscriptions',
  'subscriptions.renewalStats.renewalCount': 'Renewals',
  'subscriptions.renewalStats.successRate': 'Success',
  'subscriptions.renewalStats.cancelledCount': 'Cancelled',
  'subscriptions.renewalStats.failedCount': 'Failed',
  'subscriptions.renewalStats.pendingRetryCount': 'Pending retry (failed)',
  'subscriptions.renewalStats.pausedCount': 'Paused',
  'subscriptions.renewalStats.deletedCount': 'Deleted',
  'subscriptions.renewalStats.subscriptionCountSub': 'Period total',
  'subscriptions.renewalStats.renewalBillableSub': 'Excl. cancel/pause/delete',
  'subscriptions.renewalStats.successCountSub': '{n} succeeded / renewals',
  'subscriptions.renewalStats.pendingRetrySub': 'Active renewals with gateway',
  'subscriptions.renewalStats.pendingBillingCount': 'Pending billing',
  'subscriptions.renewalStats.failureCount': 'Failed',
  'subscriptions.renewalStats.pendingBillingSub': 'Active renewals without gateway',
  'subscriptions.renewalStats.noGateway.title': 'No gateway',
  'subscriptions.renewalStats.rateSub': '{n}% of total',
  'subscriptions.renewalStats.byPaymentMethod': 'By payment channel',
  'subscriptions.renewalStats.col.gateway': 'Gateway',
  'subscriptions.renewalStats.col.paymentMethod': 'Payment method',
  'subscriptions.renewalStats.col.success': 'Succeeded',
  'subscriptions.renewalStats.col.cancelled': 'Cancelled',
  'subscriptions.renewalStats.col.cancelledRate': 'Cancel rate',
  'subscriptions.renewalStats.col.failed': 'Failed',
  'subscriptions.renewalStats.col.pendingRetry': 'Pending retry (failed)',
  'subscriptions.renewalStats.col.paused': 'Paused',
  'subscriptions.renewalStats.col.pausedRate': 'Pause rate',
  'subscriptions.renewalStats.col.deleted': 'Deleted',
  'subscriptions.renewalStats.col.deletedRate': 'Delete rate',
  'subscriptions.renewalStats.gateway.paypal': 'PayPal',
  'subscriptions.renewalStats.gateway.ppcp': 'PayPal PPCP',
  'subscriptions.renewalStats.gateway.stripe': 'Stripe',
  'subscriptions.renewalStats.gateway.manual': 'Manual',
  'subscriptions.renewalStats.paymentMethod.card': 'Card',
  'subscriptions.renewalStats.paymentMethod.paypal': 'PayPal',
  'subscriptions.renewalStats.paymentMethod.ppcp': 'PayPal PPCP',
  'subscriptions.renewalStats.paymentMethod.apple_pay': 'Apple Pay',
  'subscriptions.renewalStats.paymentMethod.google_pay': 'Google Pay',
};
